import { render, staticRenderFns } from "./corpCertApply.vue?vue&type=template&id=42fd1ab6&scoped=true"
import script from "./corpCertApply.vue?vue&type=script&lang=js"
export * from "./corpCertApply.vue?vue&type=script&lang=js"
import style0 from "./corpCertApply.vue?vue&type=style&index=0&id=42fd1ab6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd1ab6",
  null
  
)

export default component.exports